import React, { PropTypes, useState } from 'react';
import { observer } from 'mobx-react';
import { FormSelectInput } from './SelectInput';
import TextInputClass from './Form/TextInput';

const childrenPropType = PropTypes.oneOfType([
  PropTypes.shape(),
  PropTypes.array,
]).isRequired;

const Form = ({ children, options, direction }) => <form className={`Form Form-${direction || 'column'}`} {...options}>{children}</form>;

Form.propTypes = { children: childrenPropType };
export default Form;

export const FormBody = ({ children }) => <div className="formBody">{children}</div>;
FormBody.propTypes = { children: childrenPropType };

export const FormActions = ({ children }) => <div className="formActions">{children}</div>;
FormActions.propTypes = { children: childrenPropType };

export const TextInput = TextInputClass;

export const ColorInput = observer(({
  label,
  value = '',
  onChange
}) => (
  <div className='formInput'>
    {label && (<label>{label}</label>)}
    <input type='color' value={value} onChange={onChange} />
  </div>
))

TextInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

const SelectInputBasic = observer(({
  label,
  value,
  options,
  onChange,
  fields,
}) => (
  <div className="formInput">
    <label>{label}</label>
    <select value={!!value || value === 0 ? value : ''} onChange={onChange} style={{ minWidth: '160px' }}>
      <option value={''}>--</option>
      {options && options.map((option, i) => (
        <option
          key={`select-${label}-option-${option[fields.value]}-${i}`}
          value={option[fields.value]}
        >
          {option[fields.label]}
        </option>
      ))}
    </select>
  </div>
));

export const SelectInput = props => props.useBasic ? <SelectInputBasic {...props} /> : <FormSelectInput {...props} />;

export const DateInput = observer(({
  label,
  value = '',
  readOnly,
  onChange,
  type,
  name,
  direction
}) => (
  <div className={`formInput flex ${direction || ''}`}>
    <label>{label}</label>
    <input
      name={name || ''}
      type={type ? type : "date"}
      value={value || ''}
      readOnly={readOnly}
      onChange={onChange}
    />
  </div>
));

export const SwitchInput = observer(({ label, value, onChange }) => (
  <div className='switchInput'>
    <p>{label}</p>
    <label className="switch">
      <input type="checkbox" value={value} checked={value} onChange={onChange} />
      <span className="slider round" />
    </label>
  </div>
));

export const SwitchInput2 = observer(({ label, value, onChange, numeric }) => (
  <div className='switchInput'>
    <p>{label}</p>
    <label className="switch">
      {numeric ?
        <input type="checkbox" value={+value === 1} checked={+value === 1} onChange={() => onChange({ target: { value: ~+value + 2 } })} /> :
        <input type="checkbox" value={value} checked={value} onChange={() => onChange({ target: { value: !value } })} />}
      <span className="slider round" />
    </label>
  </div>
));

export const CheckBoxInput = observer(({ label, checked, onChange, numeric }) => (
  <div className='formInput'>
    <label>{label}</label>
    {numeric ?
      <input type='checkbox' style={{ minWidth: '25px' }} checked={+checked === 1} onChange={() => onChange({ target: { checked: ~+checked + 2 } })} /> :
      <input type='checkbox' style={{ minWidth: '25px' }} checked={checked} onChange={onChange} />}
  </div>
));

export const RangeInput = observer(({
  label,
  value = {
    from: '',
    to: ''
  },
  readOnly,
  onChange,
  type = 'number',
  inputProps
}) => (
  <div className="formInput rangeInput">
    {label && (<label>{label}</label>)}
    <input
      type={type}
      value={value.from}
      readOnly={readOnly}
      onChange={e => onChange({ target: { value: { from: e.target.value, to: value.to } } })}
      {...inputProps}
    />
    <span>-</span>
    <input
      type={type}
      value={value.to}
      readOnly={readOnly}
      onChange={e => onChange({ target: { value: { from: value.from, to: e.target.value } } })}
      {...inputProps}
    />
  </div>
));

export const IconButton = ({ icon, size = 35, color, primary, onClick, style = {} }) => {
  let divStyle = { height: size, width: size, ...style };
  let iStyle = { fontSize: `${10 + size * 0.2}px`, lineHeight: `${size}px` };
  if (!!color) divStyle.backgroundColor = color;
  return (
    <div className={`icon-button ${primary ? 'icon-button-primary' : ''}`} style={divStyle} onClick={onClick}>
      <i className={icon} style={iStyle} />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Form.js